export default "__VITE_ASSET__DmSiPwLf__"